module.exports = __webpack_public_path__ + "static/media/jaison.c92eac75.webp";